import type { Accessory, AccessoryInstallType, AccessoryVersion } from './types';

const findVersion = (accessory: Accessory, type: AccessoryInstallType) =>
  accessory.versions?.find(version => version.type === type);

export const getFactoryInstallVersion = (accessory: Accessory) =>
  findVersion(accessory, 'FACTORY_INSTALL');

export const getCustomerInstallVersion = (accessory: Accessory) =>
  findVersion(accessory, 'CUSTOMER_INSTALL');

// Resolution order: the customer's persisted pick, then factory install as the
// recommended default, then whatever the API returned first.
export const getSelectedVersion = (accessory: Accessory): AccessoryVersion | undefined =>
  accessory.versions?.find(version => version.itemSku === accessory.selectedItemSku) ??
  accessory.versions?.find(version => version.isSelected) ??
  getFactoryInstallVersion(accessory) ??
  accessory.versions?.[0];

export const getVersionTotal = (version?: AccessoryVersion) =>
  version ? version.price + version.installCost : 0;

export const getAccessoryTotal = (accessory: Accessory) =>
  getVersionTotal(getSelectedVersion(accessory));

export const hasInstallChoice = (accessory: Accessory) =>
  Boolean(getFactoryInstallVersion(accessory)) && Boolean(getCustomerInstallVersion(accessory));

export const isFactoryInstallOnly = (accessory: Accessory) =>
  Boolean(getFactoryInstallVersion(accessory)) && !getCustomerInstallVersion(accessory);

export const isCustomerInstallOnly = (accessory: Accessory) =>
  Boolean(getCustomerInstallVersion(accessory)) && !getFactoryInstallVersion(accessory);
